import { QButton, QTypography, QThemeProvider, QContainer } from '@kw/quokka-ui';
import { styled } from '@mui/material/styles';
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { BackgroundProgressBar } from '../../BackgroundProgressBar/BackgroundProgressBar';
import BackButton from '../../shared/BackButton';
import { RequestAnalysisInfoContext } from './RequestAnalysisInfoContext';

export default function SubmissionQueueConfirmation() {
  const { numberOfSubmissions } = useContext(RequestAnalysisInfoContext);
  const navigate = useNavigate();
  const apps = numberOfSubmissions > 1 ? 'apps' : 'app';
  const submissionMessage = `${numberOfSubmissions} ${apps} submitted`;

  return (
    <QThemeProvider>
      <QContainer
        sx={{
          paddingTop: '16px',
          paddingBottom: '0px',
          maxWidth: '100% !important',
          display: 'flex',
          flexDirection: 'column',
          rowGap: 2,
          overflow: 'auto',
        }}
      >
        <BackgroundProgressBar />
        <BackButton href="/applications/request-analysis" text="Back to Request Analysis" />
        <SubmissionWrapper>
          <QTypography variant="h4Bold">Submission complete</QTypography>
          <StyledWrapper>
            <QTypography variant="bodyRegular" sx={{ marginBottom: '10px', display: 'inline-block' }}>
              <CheckIcon sx={{ color: '#34bfa3', fontSize: '24px', marginRight: '10px' }} />
              <span>{submissionMessage}</span>
            </QTypography>
            <QTypography variant="bodyLight" sx={{ marginLeft: '34px' }}>
              It may take a few minutes for newly requested apps to appear in the Applications page.
            </QTypography>
          </StyledWrapper>
          <div>
            <QButton variant="outlined" onClick={() => navigate('/applications/request-analysis')}>
              Return to Request Analysis
            </QButton>
            <QButton variant="filled" sx={{ marginLeft: '10px' }} onClick={() => navigate('/applications')}>
              Go to Applications
            </QButton>
          </div>
        </SubmissionWrapper>
      </QContainer>
    </QThemeProvider>
  );
}

const StyledWrapper = styled('div')`
  margin: 32px 0;
  span {
    display: flex;
    align-items: center;
  }
`;

const StyledContainer = styled('div')`
  width: 100%;
  padding: 36px 28px;
`;

const SubmissionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  margin: 20px auto;
`;
